/**
 * DownloadGate
 * ======================================
 * - markup: js-download-gate-form (the email form rendered inside the fancybox popup),
 *   the popup wrapper carries data-file-url/data-post-id with the file the user is
 *   trying to get; js-download-track marks the direct (already-unlocked) download link
 * - on successful submit (ajaxForm:success, dispatched by AjaxForm.js): remembers the
 *   visitor via a long-lived cookie (so future downloads skip the popup entirely,
 *   handled server-side in single-downloads.php), opens the requested file and tracks it
 * - every actual download (gated or not) pings ajax/forms.php so the download count
 *   shown in wp-admin stays accurate
 */

const COOKIE_NAME = 'download_access';
const COOKIE_DAYS = 365;
const AJAX_URL = '/app/themes/ipress/ajax/forms.php';

class DownloadGate {
  constructor() {
    document.querySelectorAll('.js-download-track').forEach((link) => {
      link.addEventListener('click', () => this.trackDownload(link.dataset.postId));
    });

    document.addEventListener('ajaxForm:success', (e) => {
      const form = e.target;

      if (!form.classList.contains('js-download-gate-form')) return;

      const wrapper = form.closest('[data-file-url]');
      const fileUrl = wrapper ? wrapper.dataset.fileUrl : null;
      const postId = wrapper ? wrapper.dataset.postId : null;

      this.setCookie(COOKIE_NAME, '1', COOKIE_DAYS);

      if (fileUrl) {
        // Safari (and some other browsers) block window.open() here since, by the time
        // this async XHR callback runs, it's no longer considered a direct result of the
        // user's click - so the fallback link in the success message is not just a nicety,
        // it's the only way some visitors will actually get the file.
        const fallbackLink = wrapper.querySelector('.js-download-fallback-link');
        if (fallbackLink) fallbackLink.href = fileUrl;

        window.open(fileUrl, '_blank');
        this.trackDownload(postId);
      }
    });
  }

  trackDownload = (postId) => {
    if (!postId) return;

    const formData = new FormData();
    formData.append('ajaxForm', 'track_download');
    formData.append('post_id', postId);

    navigator.sendBeacon(AJAX_URL, formData);
  }

  setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
  }
}

new DownloadGate();
